var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLeft = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38476 17.3053L3.38477 2.38446C3.38477 2.0017 3.07447 1.69141 2.69171 1.69141C2.30895 1.69141 1.99866 2.0017 1.99866 2.38446L1.99866 17.3053C1.99866 17.6878 2.30914 17.9983 2.69171 17.9983C3.07428 17.9983 3.38476 17.6878 3.38476 17.3053Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82754 10.5L16.6328 10.5C17.047 10.5 17.3828 10.1642 17.3828 9.75C17.3828 9.33579 17.047 9 16.6328 9L7.82754 9L7.82754 6.75L4.83504 9.75L7.82754 12.75L7.82754 10.5Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/left.0ffb4a7e.svg";
export { ForwardRef as ReactComponent };